import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';
import type { AgenticEditorBannerProps } from './AgenticEditorBanner.tsx';

export const AgenticEditorBannerLoader: LoadableType<AgenticEditorBannerProps> = LoadableAfterPaint(
	{
		loader: async () =>
			(
				await import(
					/* webpackChunkName: "loadable-AgenticEditorBanner" */ './AgenticEditorBanner.tsx'
				)
			).AgenticEditorBanner,
	},
);
